<div class="p-dialog dialog card-container" style="max-width: 500px; margin-top: 5vw">
  <button pButton type="button" icon="pi pi-times"
          [style]="{'margin-left':'410px', 'margin-top':'-20px'}"
          class="p-button-rounded p-button-text p-button-plain title-button"
          (click)="onClose()"></button>
  <div style="margin: 0 5% 20px" class="p-d-flex p-ai-center">
    <img
      id="profile-img"
      src="assets/user.png"
      class="profile-img-card p-d-none p-d-md-inline-flex" style="margin-right:20px;"
    />
    <span style="font-size:30px;">User Registration</span>
  </div>
  <div *ngIf="!isSuccessful" style="margin: 0 5px 25px 5px;">
    Please populate all fields. A temporary password will be sent to your email after you click the "Sign Up" button.
  </div>
  <form
    *ngIf="!isSuccessful"
    name="form"
    (ngSubmit)="f.form.valid && onSubmit()"
    #f="ngForm"
    novalidate
  >
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12 p-md-6">
        <span class="p-float-label">
          <input
            type="text"
            id="username"
            pInputText
            name="username"
            [(ngModel)]="form.username"
            required
            minlength="3"
            maxlength="20"
            #username="ngModel"
          />
          <label for="username">Username</label>
        </span>
        <div class="alert" *ngIf="username.errors && f.submitted">
          <div *ngIf="username.errors.required">Username is required</div>
          <div *ngIf="username.errors.minlength">
            Username must be at least 3 characters
          </div>
          <div *ngIf="username.errors.maxlength">
            Username must be at most 20 characters
          </div>
        </div>
      </div>
      <div class="p-field p-col-12 p-md-6">
        <span class="p-float-label">
          <input
                  type="email"
                  id="email"
                  name="email"
                  pInputText
                  [(ngModel)]="form.email"
                  required
                  email
                  #email="ngModel"
          />
          <label for="email">Email</label>
          <div class="alert" *ngIf="email.errors && f.submitted">
            <div *ngIf="email.errors.required">Email is required</div>
            <div *ngIf="email.errors.email">
              Email must be a valid email address
            </div>
          </div>
        </span>
      </div>

      <div class="p-field p-col-12 p-md-6">
        <span class="p-float-label">
          <input
            type="text"
            id="firstName"
            name="firstName"
            pInputText
            [(ngModel)]="form.firstName"
            required
            #firstName="ngModel"
          />
          <label for="firstName">First Name</label>
        </span>
        <div class="alert" *ngIf="firstName.errors && f.submitted">
          <div *ngIf="firstName.errors.required">First Name is required</div>
        </div>
      </div>
      <div class="p-field p-col-12 p-md-6">
        <span class="p-float-label">
          <input
            type="text"
            id="lastName"
            name="lastName"
            pInputText
            [(ngModel)]="form.lastName"
            required
            #lastName="ngModel"
          />
          <label for="lastName">Last Name</label>
        </span>
        <div class="alert" *ngIf="lastName.errors && f.submitted">
          <div *ngIf="lastName.errors.required">Last Name is required</div>
        </div>
      </div>
      <div class="p-field p-col-12 p-md-12">
        <span class="p-float-label">
          <input
            type="text"
            id="company"
            name="company"
            pInputText
            [(ngModel)]="form.company"
            required
            #company="ngModel"
          />
          <label for="company">Company</label>
        </span>
        <div class="alert" *ngIf="company.errors && f.submitted">
          <div *ngIf="company.errors.required">Company is required</div>
        </div>
      </div>

      <Input class="button_black" Type="Submit" Value="Sign Up" style="width:100%; margin: 10px 10px; height:35px;" />

      <div class="alert alert-warning" *ngIf="f.submitted && isSignUpFailed">
        Signup failed!<br />{{ errorMessage }}
      </div>
    </div>
  </form>

  <div style="font-size:16px;" *ngIf="isSuccessful">
    <p>Congratulations, your registration is successful!</p>
    <p>A temporary password has been sent to your email. Enjoy your free trial!</p>
    <button pButton type="button" label="Login"
            [style]="{'margin':'10px 180px'}"
            (click)="onClose()"></button>
  </div>
</div>

<img class="progress-spinner rotate" *ngIf="isBusy" src="assets/loading.png" alt="loading...">
